export { default as FreeLabel } from './FreeLabel.vue';
